import {selectCombinedFeatureFlags} from '../state/featureFlags/featureFlagsSelector';
import {useSelector} from '../state/hooks';

const useFeatureFlag = (flag) => {
  const featureFlags = useSelector(selectCombinedFeatureFlags);
  return featureFlags[`${flag}Enabled`] === true;
};

export default useFeatureFlag;
